/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AgreeToOlInfoSharingConsent200Response
 */
export interface AgreeToOlInfoSharingConsent200Response {
    /**
     * 
     * @type {string}
     * @memberof AgreeToOlInfoSharingConsent200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof AgreeToOlInfoSharingConsent200Response
     */
    'status': AgreeToOlInfoSharingConsent200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AgreeToOlInfoSharingConsent200Response
     */
    'consentedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof AgreeToOlInfoSharingConsent200Response
     */
    'consentedAt': string | null;
}

export const AgreeToOlInfoSharingConsent200ResponseStatusEnum = {
    notConsented: 'NOT_CONSENTED',
    consented: 'CONSENTED'
} as const;

export type AgreeToOlInfoSharingConsent200ResponseStatusEnum = typeof AgreeToOlInfoSharingConsent200ResponseStatusEnum[keyof typeof AgreeToOlInfoSharingConsent200ResponseStatusEnum];


